import React, {FC} from "react";
import {useService} from "../redux/services.hook";
import {Chip, ChipProps} from "@material-ui/core";
import {Skeleton} from "@material-ui/lab";

export const ServiceChip: FC<{ id: string; size?: ChipProps["size"] }> = ({id, size = "small"}) => {
    const {service} = useService(id);
    return (
        service?.active
            ? <Chip style={{margin: 1}} label={service?.name ?? <Skeleton height={12} width={60}/>} size={size}/>
            : <></>
    )
}

export const ServiceChips: FC<{ serviceIds: string[], initialAmount?: number; size?: ChipProps["size"] }> = ({
                                                                                                                 serviceIds,
                                                                                                                 initialAmount = 2,
                                                                                                                 size = "small"
                                                                                                             }) => {

    const [showAllServices, setShowAllServices] = React.useState(false);

    const visibleServices = serviceIds.slice(0, showAllServices ? undefined : initialAmount + 1);

    return (
        <div style={{display: "flex", flexWrap: "wrap"}}>
            {(visibleServices).map((id) =>
                <ServiceChip size={size} key={"serviceChip" + id} id={id}/>)}
            {serviceIds.length > initialAmount + 1 && !showAllServices && (
                <Chip
                    size={size}
                    label="..."
                    onClick={(event) => {
                        event.stopPropagation();
                        setShowAllServices(true);
                    }}
                />
            )}
        </div>
    )
}
